import { render, staticRenderFns } from "./ProductPurchase.vue?vue&type=template&id=ad698802&scoped=true"
import script from "./ProductPurchase.vue?vue&type=script&lang=ts"
export * from "./ProductPurchase.vue?vue&type=script&lang=ts"
import style0 from "./ProductPurchase.vue?vue&type=style&index=0&id=ad698802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad698802",
  null
  
)

export default component.exports